import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Workshop tablet: when an "atolye" account has selected a worker, attach the
// acting worker id so the backend attributes all actions to that worker.
api.interceptors.request.use((config) => {
  const actingId = localStorage.getItem("acting_usta_id");
  if (actingId) {
    config.headers = config.headers || {};
    config.headers["X-Acting-User-Id"] = actingId;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu, lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
